import * as React from "react";

export const NotificationBellIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 18.3333C10.9167 18.3333 11.6667 17.5833 11.6667 16.6667H8.33337C8.33337 17.5833 9.08337 18.3333 10 18.3333ZM15 13.3333V9.16666C15 6.60833 13.6417 4.46666 11.25 3.89999V3.33333C11.25 2.64166 10.6917 2.08333 10 2.08333C9.30837 2.08333 8.75004 2.64166 8.75004 3.33333V3.89999C6.36671 4.46666 5.00004 6.59999 5.00004 9.16666V13.3333L3.33337 15V15.8333H16.6667V15L15 13.3333ZM13.3334 14.1667H6.66671V9.16666C6.66671 7.09999 7.92504 5.41666 10 5.41666C12.075 5.41666 13.3334 7.09999 13.3334 9.16666V14.1667Z"
                fill="black"
                fill-opacity="0.54"
            />
        </svg>
    );
};
